import React from "react";



export const Logo = () => {
  return (
    <div>
      <svg
        width="30"
        height="30"
        viewBox="0 0 34 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2593 5.36497C18.2593 4.64269 18.0608 3.93034 17.6794 3.28431C17.3498 2.72589 17.1562 2.11699 17.1103 1.49387L17 0L16.8898 1.49382C16.8438 2.11695 16.6502 2.72587 16.3206 3.28429C15.9393 3.93033 15.7407 4.64271 15.7407 5.36499V26.635C15.7407 27.3573 15.9393 28.0697 16.3206 28.7157C16.6502 29.2741 16.8438 29.8831 16.8898 30.5062L17 32L17.1103 30.5061C17.1562 29.883 17.3498 29.2741 17.6794 28.7157C18.0608 28.0697 18.2593 27.3573 18.2593 26.635V5.36497ZM11.3831 5.41765C11.7645 6.06367 11.963 6.77607 11.963 7.49833V24.5017C11.963 25.224 11.7645 25.9363 11.3831 26.5824C11.0535 27.1408 10.8599 27.7497 10.8139 28.3728L10.7037 29.8667L10.5935 28.3728C10.5475 27.7497 10.3539 27.1408 10.0243 26.5824C9.64293 25.9363 9.44444 25.224 9.44444 24.5017V7.49833C9.44444 6.77607 9.64293 6.06367 10.0243 5.41765C10.3539 4.85922 10.5475 4.25031 10.5935 3.62719L10.7037 2.13334L10.8139 3.62719C10.8599 4.25031 11.0535 4.85922 11.3831 5.41765ZM8.81481 9.63167C8.81481 8.90933 8.61632 8.197 8.23493 7.551C7.90531 6.99253 7.71176 6.38363 7.66578 5.76051L7.55556 4.26666L7.44533 5.76051C7.39935 6.38363 7.20579 6.99253 6.87616 7.551C6.49483 8.197 6.2963 8.90933 6.2963 9.63167V22.3683C6.2963 23.0906 6.49483 23.803 6.87616 24.449C7.20579 25.0075 7.39935 25.6163 7.44533 26.2395L7.55556 27.7333L7.66578 26.2395C7.71176 25.6163 7.90531 25.0075 8.23493 24.449C8.61632 23.803 8.81481 23.0906 8.81481 22.3683V9.63167ZM5.0868 11.8176C5.46814 12.4637 5.66667 13.176 5.66667 13.8983V18.1017C5.66667 18.8239 5.46814 19.5363 5.0868 20.1823C4.75717 20.7408 4.56361 21.3497 4.51763 21.9728L4.40741 23.4667L4.29718 21.9728C4.2512 21.3497 4.05764 20.7408 3.72801 20.1823C3.34668 19.5363 3.14815 18.8239 3.14815 18.1017V13.8983C3.14815 13.176 3.34668 12.4637 3.72801 11.8176C4.05764 11.2592 4.2512 10.6503 4.29718 10.0272L4.40741 8.53333L4.51763 10.0272C4.56361 10.6503 4.75717 11.2592 5.0868 11.8176ZM2.51839 16L2.51852 16.0317V15.9683L2.51839 16ZM0 16.0317L0.000127045 16C0.00583922 16.7115 0.2041 17.4125 0.579866 18.049C0.909492 18.6075 1.10306 19.2163 1.14903 19.8395L1.25926 21.3333L1.36948 19.8395C1.41546 19.2163 1.60903 18.6075 1.93865 18.049C2.31442 17.4125 2.51268 16.7115 2.51839 16C2.51268 15.2885 2.31442 14.5875 1.93865 13.951C1.60903 13.3925 1.41546 12.7837 1.36948 12.1605L1.25926 10.6667L1.14903 12.1605C1.10306 12.7837 0.909492 13.3925 0.579866 13.951C0.2041 14.5875 0.00583924 15.2885 0.000127045 16L0 15.9683V16.0317ZM14.5312 3.28431C14.9126 3.93033 15.1111 4.6427 15.1111 5.36498V26.635C15.1111 27.3573 14.9126 28.0697 14.5312 28.7157C14.2016 29.2741 14.0081 29.883 13.962 30.5061L13.8519 32L13.7417 30.5061C13.6956 29.883 13.5021 29.2741 13.1725 28.7157C12.7911 28.0697 12.5926 27.3573 12.5926 26.635V5.36498C12.5926 4.6427 12.7911 3.93033 13.1725 3.28431C13.5021 2.72588 13.6956 2.11697 13.7417 1.49385L13.8519 0L13.962 1.49385C14.0081 2.11697 14.2016 2.72588 14.5312 3.28431ZM20.8275 3.28431C21.2089 3.93033 21.4074 4.6427 21.4074 5.36498V26.635C21.4074 27.3573 21.2089 28.0697 20.8275 28.7157C20.4979 29.2741 20.3044 29.883 20.2583 30.5061L20.1481 32L20.038 30.5061C19.9919 29.883 19.7984 29.2741 19.4688 28.7157C19.0874 28.0697 18.8889 27.3573 18.8889 26.635V5.36498C18.8889 4.6427 19.0874 3.93033 19.4688 3.28431C19.7984 2.72588 19.9919 2.11697 20.038 1.49385L20.1481 0L20.2583 1.49385C20.3044 2.11697 20.4979 2.72588 20.8275 3.28431ZM24.5556 7.49833C24.5556 6.77607 24.3571 6.06367 23.9757 5.41765C23.6461 4.85922 23.4525 4.25031 23.4065 3.62719L23.2963 2.13334L23.1861 3.62719C23.1401 4.25031 22.9465 4.85922 22.6169 5.41765C22.2355 6.06367 22.037 6.77607 22.037 7.49833V24.5017C22.037 25.224 22.2355 25.9363 22.6169 26.5824C22.9465 27.1408 23.1401 27.7497 23.1861 28.3728L23.2963 29.8667L23.4065 28.3728C23.4525 27.7497 23.6461 27.1408 23.9757 26.5824C24.3571 25.9363 24.5556 25.224 24.5556 24.5017V7.49833ZM27.1238 7.551C27.5052 8.197 27.7037 8.90933 27.7037 9.63167V22.3683C27.7037 23.0906 27.5052 23.803 27.1238 24.449C26.7942 25.0075 26.6007 25.6163 26.5546 26.2395L26.4444 27.7333L26.3343 26.2395C26.2882 25.6163 26.0947 25.0075 25.7651 24.449C25.3838 23.803 25.1852 23.0906 25.1852 22.3683V9.63167C25.1852 8.90933 25.3838 8.197 25.7651 7.551C26.0947 6.99253 26.2882 6.38363 26.3343 5.76051L26.4444 4.26666L26.5546 5.76051C26.6007 6.38363 26.7942 6.99253 27.1238 7.551ZM30.8519 13.8983C30.8519 13.176 30.6534 12.4637 30.272 11.8176C29.9424 11.2592 29.7488 10.6503 29.7028 10.0272L29.5926 8.53333L29.4824 10.0272C29.4364 10.6503 29.2428 11.2592 28.9132 11.8176C28.5319 12.4637 28.3333 13.176 28.3333 13.8983V18.1017C28.3333 18.8239 28.5319 19.5363 28.9132 20.1823C29.2428 20.7408 29.4364 21.3497 29.4824 21.9728L29.5926 23.4667L29.7028 21.9728C29.7488 21.3497 29.9424 20.7408 30.272 20.1823C30.6534 19.5363 30.8519 18.8239 30.8519 18.1017V13.8983ZM33.9998 16C33.9999 16.0105 34 16.0211 34 16.0317V15.9683C34 15.9789 33.9999 15.9895 33.9998 16ZM31.4816 16C31.4873 16.7115 31.6856 17.4125 32.0614 18.049C32.391 18.6075 32.5845 19.2163 32.6306 19.8395L32.7407 21.3333L32.8509 19.8395C32.897 19.2163 33.0905 18.6075 33.4201 18.049C33.7959 17.4125 33.9942 16.7115 33.9998 16C33.9942 15.2885 33.7959 14.5875 33.4201 13.951C33.0905 13.3925 32.897 12.7837 32.8509 12.1605L32.7407 10.6667L32.6306 12.1605C32.5845 12.7837 32.391 13.3925 32.0614 13.951C31.6856 14.5875 31.4873 15.2885 31.4816 16ZM31.4816 16C31.4816 15.9895 31.4815 15.9789 31.4815 15.9683V16.0317C31.4815 16.0211 31.4816 16.0105 31.4816 16Z"
          fill="#394149"
        />
      </svg>
    </div>
  );
};

export function Icon({
  path,
  w = "w-6",
  h = "h-6",
  size = null,
  className = "",
  children,
}) {
  const iconSize = size ?? 16;

  return (
    <span
      className={`inline-flex justify-center items-center ${w} ${h} ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        width={iconSize}
        height={iconSize}
        className="inline-block"
      >
        <path fill="currentColor" d={path} />
      </svg>
      {children}
    </span>
  );
}

export const UzbFlag = () => {
  return (
    <div>
      {" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-6 me-2"
        viewBox="0 0 32 32"
      >
        <path fill="#fff" d="M1 11H31V21H1z"></path>
        <path
          d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
          fill="#4498b3"
        ></path>
        <path
          d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
          transform="rotate(180 16 24)"
          fill="#55b44b"
        ></path>
        <path fill="#be2a2c" d="M1 12H31V13H1z"></path>
        <path fill="#be2a2c" d="M1 19H31V20H1z"></path>
        <path
          d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z"
          opacity=".15"
        ></path>
        <path
          d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z"
          fill="#fff"
          opacity=".2"
        ></path>
        <path
          d="M7.417,6.51c-.127-.021-.257-.033-.39-.033-1.291,0-2.338,1.047-2.338,2.338s1.047,2.338,2.338,2.338c.133,0,.263-.012,.39-.033-1.105-.186-1.948-1.146-1.948-2.305s.843-2.119,1.948-2.305Z"
          fill="#fff"
        ></path>
        <path
          fill="#fff"
          d="M9.741 10.181L9.564 9.635 9.387 10.181 8.813 10.181 9.277 10.518 9.1 11.063 9.564 10.726 10.028 11.063 9.851 10.518 10.315 10.181 9.741 10.181z"
        ></path>
        <path
          fill="#fff"
          d="M12.899 10.181L12.722 9.635 12.544 10.181 11.971 10.181 12.435 10.518 12.258 11.063 12.722 10.726 13.186 11.063 13.009 10.518 13.473 10.181 12.899 10.181z"
        ></path>
        <path
          fill="#fff"
          d="M12.722 6.477L12.544 7.023 11.971 7.023 12.435 7.36 12.258 7.905 12.722 7.568 13.186 7.905 13.009 7.36 13.473 7.023 12.899 7.023 12.722 6.477z"
        ></path>
      </svg>
    </div>
  );
};

export const RuFlag = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4 rounded-full me-2"
        viewBox="0 0 32 32"
      >
        <path fill="#1435a1" d="M1 11H31V21H1z"></path>
        <path
          d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
          fill="#fff"
        ></path>
        <path
          d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
          transform="rotate(180 16 24)"
          fill="#c53a28"
        ></path>
        <path
          d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z"
          opacity=".15"
        ></path>
        <path
          d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z"
          fill="#fff"
          opacity=".2"
        ></path>
      </svg>
    </div>
  );
};

export const Burger = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </div>
  );
};

export const Arrow = () => {
  return (
    <div>
      <svg
        width="17.000000"
        height="14.000000"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs />
        <path
          id="Stroke 1"
          d="M15.75 6.22L0.75 6.22"
          stroke="#25324B"
          strokeOpacity="1.000000"
          strokeWidth="2.000000"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <path
          id="Stroke 3"
          d="M9.7 0.2L15.75 6.22L9.7 12.25"
          stroke="#25324B"
          strokeOpacity="1.000000"
          strokeWidth="2.000000"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export const SignUpArrow = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M19 12H5m14 0-4 4m4-4-4-4"
        />
      </svg>
    </div>
  );
};

export const SignUpPhone = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};
export const SignUpPassword = () => {
  return (
    <div>
      {" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    </div>
  );
};

export const FileUpload = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 fill-white stroke-indigo-500"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    </div>
  );
};

export const TelegramIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="24"
        height="24"
        viewBox="0 0 48 48"
      >
        <path
          fill="#29b6f6"
          d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"
        ></path>
        <path
          fill="#fff"
          d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"
        ></path>
        <path
          fill="#b0bec5"
          d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"
        ></path>
        <path
          fill="#cfd8dc"
          d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"
        ></path>
      </svg>
    </div>
  );
};

export const HeaderFilter = () => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.60851 13.8274H3.35791"
          stroke="#1E3E5C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9507 5.75035H16.2013"
          stroke="#1E3E5C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.27207 5.70521C7.27207 4.6255 6.39027 3.75 5.30278 3.75C4.2153 3.75 3.3335 4.6255 3.3335 5.70521C3.3335 6.78492 4.2153 7.66042 5.30278 7.66042C6.39027 7.66042 7.27207 6.78492 7.27207 5.70521Z"
          stroke="#1E3E5C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6666 13.7948C16.6666 12.7151 15.7855 11.8396 14.698 11.8396C13.6098 11.8396 12.728 12.7151 12.728 13.7948C12.728 14.8745 13.6098 15.75 14.698 15.75C15.7855 15.75 16.6666 14.8745 16.6666 13.7948Z"
          stroke="#1E3E5C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const SearchIcon = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-500 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
        />
      </svg>
    </div>
  );
};

export const HeaderBell = () => {
  return (
    <div>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99717 1.88562C5.67145 1.88562 4.22645 4.89705 4.22645 6.88776C4.22645 8.37562 4.44217 7.93776 3.61859 9.75276C2.61288 12.3392 6.65717 13.3963 8.99717 13.3963C11.3365 13.3963 15.3807 12.3392 14.3757 9.75276C13.5522 7.93776 13.7679 8.37562 13.7679 6.88776C13.7679 4.89705 12.3222 1.88562 8.99717 1.88562Z"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7296 15.3842C9.75893 16.4684 8.24465 16.4813 7.26465 15.3842"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="14.25" cy="11.25" r="2.25" fill="#F75555" />
      </svg>
    </div>
  );
};

export const CategoryCompany = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#246BFD" />
        <path
          d="M17.5 14.5H19.5L20 13L19.5 12.5H18.5L17.5 14M13 8.5C13 29.7 22.3333 17.3333 27 8.5V30H12.5L13 8.5Z"
          stroke="white"
        />
        <path d="M18.5 14.5H17L17.5 13.5" stroke="white" />
        <path
          d="M17.5 22.5V25.25M17.5 28V25.25M17.5 25.25L19.5 23.5L17.6722 25.25L19.5 27L20.5 28"
          stroke="white"
        />
      </svg>
    </div>
  );
};

export const BusiniessRole = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.65967 17.7085L11.6505 12.5217L16.2028 16.0976L20.1082 11.0571"
        stroke="url(#paint0_linear_1628_2220)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="24.6606"
        cy="3.60028"
        r="2.56293"
        stroke="url(#paint1_linear_1628_2220)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8994 2.16016H8.20906C4.1938 2.16016 1.7041 5.00379 1.7041 9.01904V19.7955C1.7041 23.8108 4.14499 26.6422 8.20906 26.6422H19.6812C23.6965 26.6422 26.1862 23.8108 26.1862 19.7955V10.4103"
        stroke="url(#paint2_linear_1628_2220)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1628_2220"
          x1="13.8839"
          y1="11.0571"
          x2="13.8839"
          y2="17.7085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7FCD31" />
          <stop offset="1" stop-color="#43C05E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1628_2220"
          x1="24.6606"
          y1="1.03735"
          x2="24.6606"
          y2="6.16321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7FCD31" />
          <stop offset="1" stop-color="#43C05E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1628_2220"
          x1="13.9451"
          y1="2.16016"
          x2="13.9451"
          y2="26.6422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7FCD31" />
          <stop offset="1" stop-color="#43C05E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CategoryJobs = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#246BFD" />
        <path
          d="M2.34279 26C0.578084 16.3765 0.526768 10.9084 2.34279 1H4.34279C6.17071 10.8377 6.14027 16.3029 4.34279 26H2.34279Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};

export const CategoryTop = () => {
  return (
    <div>
      {" "}
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 10L6 3"
          stroke="#00BB29"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 6.5L6 3L9.5 6.5"
          stroke="#00BB29"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const SignUpArrowBack = () => {
  return (
    <div>
      <svg
        width="10"
        height="21"
        viewBox="0 0 10 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.99347 10.007L9.88463 0.704919C10.0433 0.538391 10.0376 0.274525 9.87162 0.115307C9.70642 -0.0439117 9.44273 -0.0369925 9.28241 0.128324L0.115347 9.71868C-0.0384489 9.87993 -0.0384489 10.134 0.115347 10.2953L9.28241 19.8857C9.3646 19.9712 9.47367 20.0144 9.58352 20.0144C9.68688 20.0144 9.79107 19.9761 9.87162 19.8987C10.0376 19.7395 10.0433 19.4756 9.88463 19.3091L0.99347 10.007Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export const BackSingle = () => {
  return (
    <div>
      {" "}
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.3335 14.3199C23.3335 14.7629 23.0043 15.129 22.5772 15.187L22.4585 15.1949L4.95849 15.1949C4.47525 15.1949 4.08349 14.8032 4.08349 14.3199C4.08349 13.877 4.41267 13.5109 4.83976 13.4529L4.95849 13.4449L22.4585 13.4449C22.9417 13.4449 23.3335 13.8367 23.3335 14.3199Z"
          fill="#212121"
        />
        <path
          d="M12.634 20.7284C12.9764 21.0694 12.9776 21.6234 12.6367 21.9658C12.3267 22.2771 11.8406 22.3064 11.4975 22.053L11.3992 21.9685L4.34088 14.9405C4.02864 14.6296 4.00024 14.1418 4.25568 13.7987L4.34083 13.7004L11.3992 6.67126C11.7416 6.33026 12.2956 6.33141 12.6366 6.67382C12.9466 6.98511 12.9738 7.47128 12.719 7.8133L12.634 7.91126L6.19867 14.3208L12.634 20.7284Z"
          fill="#212121"
        />
      </svg>
    </div>
  );
};

export const BackSingleJobseeker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12H6M12 5l-7 7 7 7" />
    </svg>
  );
};

export const Candidats = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="user-square">
          <path
            id="Icon"
            d="M18.2197 60C19.3225 52 24.6614 48 36.0004 48C47.3393 48 52.6782 52 53.781 60M36 39C40 39 42 36.8571 42 31.5C42 26.1429 40 24 36 24C32 24 30 26.1429 30 31.5C30 36.8571 32 39 36 39ZM18 60H54C57.3137 60 60 57.3137 60 54V18C60 14.6863 57.3137 12 54 12H18C14.6863 12 12 14.6863 12 18V54C12 57.3137 14.6863 60 18 60Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
};

export const QuickJobsIcon = () => {
  return (
    <div>
      <svg
        className="h-40 w-16"
        viewBox="0 0 64 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Mask group">
          <path
            id="Rectangle 12"
            d="M0 0H32C47.0849 0 54.6274 0 59.3137 4.68629C64 9.37258 64 16.9151 64 32V82C64 97.0849 64 104.627 59.3137 109.314C54.6274 114 47.0849 114 32 114H0V0Z"
            fill="#5081AF"
          />
          <mask
            id="mask0_1131_6929"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="64"
            height="160"
          >
            <path
              id="Rectangle 13"
              d="M0 0H32C47.0849 0 54.6274 0 59.3137 4.68629C64 9.37258 64 16.9151 64 32V82C64 97.0849 64 104.627 59.3137 109.314C54.6274 114 47.0849 114 32 114H0V0Z"
              fill="#50AF95"
            />
          </mask>
          <g mask="url(#mask0_1131_6929)">
            <path
              id="Vector"
              opacity="0.08"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.1402 58.5L94.891 91.0028L115.04 70.7652C118.704 67.0856 124.199 67.0856 127.252 70.7652C130.916 74.4448 130.916 80.5774 127.252 84.2569L100.997 111.24C97.3333 114.92 91.838 114.92 88.1745 111.24L50.3178 71.9917V95.2956C50.3178 100.202 46.0436 104.494 41.1589 104.494C36.2741 104.494 32 100.202 32 95.2956L32 21.7044C32 16.7983 36.2741 12.5055 41.1589 12.5055C46.0436 12.5055 50.3178 16.7983 50.3178 21.7044V45.0083L88.1745 5.75967C91.838 2.08011 97.3333 2.08011 100.997 5.75967L127.252 32.7431C130.916 36.4227 130.916 42.5552 127.252 46.2348C123.589 49.9144 118.093 49.9144 115.04 46.2348L94.891 25.384L63.1402 58.5ZM94.891 49.3011C99.7757 49.3011 104.05 53.5939 104.05 58.5C104.05 63.4061 99.7757 67.6989 94.891 67.6989C90.0062 67.6989 85.7321 63.4061 85.7321 58.5C85.7321 53.5939 90.0062 49.3011 94.891 49.3011Z"
              fill="white"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export const ArrowProfile = () => {
  return (
    <div>
      {" "}
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.08325 4.16659L12.9166 9.99992L7.08325 15.8333"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const ProfileAvatar = () => {
  return (
    <div>
      <svg
        className="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
  "
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(2 3)">
          <path d="M20 16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3l2-3h6l2 3h3a2 2 0 0 1 2 2v11z" />
          <circle cx="10" cy="10" r="4" />
        </g>
      </svg>
    </div>
  );
};

export const ProfileName = () => {
  return (
    <div>
      {" "}
      <svg
        width="24"
        height="24"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0002 2.33325C12.4681 2.33325 10.951 2.63502 9.53552 3.22132C8.12006 3.80763 6.83393 4.66699 5.75058 5.75034C3.56266 7.93826 2.3335 10.9057 2.3335 13.9999C2.3335 17.0941 3.56266 20.0616 5.75058 22.2495C6.83393 23.3328 8.12006 24.1922 9.53552 24.7785C10.951 25.3648 12.4681 25.6666 14.0002 25.6666C17.0944 25.6666 20.0618 24.4374 22.2497 22.2495C24.4377 20.0616 25.6668 17.0941 25.6668 13.9999C25.6668 12.4678 25.3651 10.9507 24.7788 9.53528C24.1925 8.11981 23.3331 6.83369 22.2497 5.75034C21.1664 4.66699 19.8803 3.80763 18.4648 3.22132C17.0493 2.63502 15.5323 2.33325 14.0002 2.33325ZM8.2485 21.3266C8.75016 20.2766 11.8068 19.2499 14.0002 19.2499C16.1935 19.2499 19.2502 20.2766 19.7518 21.3266C18.1652 22.5866 16.1702 23.3333 14.0002 23.3333C11.8302 23.3333 9.83516 22.5866 8.2485 21.3266ZM21.4202 19.6349C19.7518 17.6049 15.7035 16.9166 14.0002 16.9166C12.2968 16.9166 8.2485 17.6049 6.58016 19.6349C5.39016 18.0833 4.66683 16.1233 4.66683 13.9999C4.66683 8.85492 8.85516 4.66659 14.0002 4.66659C19.1452 4.66659 23.3335 8.85492 23.3335 13.9999C23.3335 16.1233 22.6102 18.0833 21.4202 19.6349ZM14.0002 6.99992C11.7368 6.99992 9.91683 8.81992 9.91683 11.0833C9.91683 13.3466 11.7368 15.1666 14.0002 15.1666C16.2635 15.1666 18.0835 13.3466 18.0835 11.0833C18.0835 8.81992 16.2635 6.99992 14.0002 6.99992ZM14.0002 12.8333C13.536 12.8333 13.0909 12.6489 12.7627 12.3207C12.4345 11.9925 12.2502 11.5474 12.2502 11.0833C12.2502 10.6191 12.4345 10.174 12.7627 9.84582C13.0909 9.51763 13.536 9.33325 14.0002 9.33325C14.4643 9.33325 14.9094 9.51763 15.2376 9.84582C15.5658 10.174 15.7502 10.6191 15.7502 11.0833C15.7502 11.5474 15.5658 11.9925 15.2376 12.3207C14.9094 12.6489 14.4643 12.8333 14.0002 12.8333Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export const ProfileResume = () => {
  return (
    <div>
      {" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <polyline points="17 11 19 13 23 9"></polyline>
      </svg>
    </div>
  );
};

export const ProfileApplied = () => {
  return (
    <div>
      <svg
        class="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z"
        />
      </svg>
    </div>
  );
};
export const ProfileTelegram = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25"
      height="25"
      viewBox="0 0 64 64"
    >
      <path d="M 32 10 C 19.85 10 10 19.85 10 32 C 10 44.15 19.85 54 32 54 C 44.15 54 54 44.15 54 32 C 54 19.85 44.15 10 32 10 z M 32 14 C 41.941 14 50 22.059 50 32 C 50 41.941 41.941 50 32 50 C 22.059 50 14 41.941 14 32 C 14 22.059 22.059 14 32 14 z M 41.041016 23.337891 C 40.533078 23.279297 39.894891 23.418531 39.181641 23.675781 C 37.878641 24.145781 21.223719 31.217953 20.261719 31.626953 C 19.350719 32.014953 18.487328 32.437828 18.486328 33.048828 C 18.486328 33.478828 18.741312 33.721656 19.445312 33.972656 C 20.177313 34.234656 22.023281 34.79275 23.113281 35.09375 C 24.163281 35.38275 25.357344 35.130844 26.027344 34.714844 C 26.736344 34.273844 34.928625 28.7925 35.515625 28.3125 C 36.102625 27.8325 36.571797 28.448688 36.091797 28.929688 C 35.611797 29.410688 29.988094 34.865094 29.246094 35.621094 C 28.346094 36.539094 28.985844 37.490094 29.589844 37.871094 C 30.278844 38.306094 35.239328 41.632016 35.986328 42.166016 C 36.733328 42.700016 37.489594 42.941406 38.183594 42.941406 C 38.877594 42.941406 39.242891 42.026797 39.587891 40.966797 C 39.992891 39.725797 41.890047 27.352062 42.123047 24.914062 C 42.194047 24.175062 41.960906 23.683844 41.503906 23.464844 C 41.365656 23.398594 41.210328 23.357422 41.041016 23.337891 z"></path>
    </svg>
  );
};
export const ProfileAppliedJob = () => {
  return (
    <div>
      <svg
        class="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 9h3m-3 3h3m-3 3h3m-6 1c-.306-.613-.933-1-1.618-1H7.618c-.685 0-1.312.387-1.618 1M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        />
      </svg>
    </div>
  );
};

export const ProfileLang = () => {
  return (
    <div>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.2085 14.0002C3.2085 5.907 5.907 3.2085 14.0002 3.2085C22.0933 3.2085 24.7918 5.907 24.7918 14.0002C24.7918 22.0933 22.0933 24.7918 14.0002 24.7918C5.907 24.7918 3.2085 22.0933 3.2085 14.0002Z"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7387 16.2166H17.7492"
          stroke="#212121"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2387 11.5501H14.2492"
          stroke="#212121"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.728 16.2166H10.7385"
          stroke="#212121"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const ProfileAbout = () => {
  return (
    <div>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.792 13.9998C24.792 22.093 22.0935 24.7915 14.0003 24.7915C5.90716 24.7915 3.20866 22.093 3.20866 13.9998C3.20866 5.90667 5.90716 3.20817 14.0003 3.20817C22.0935 3.20817 24.792 5.90667 24.792 13.9998Z"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0002 18.5442V14"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0054 9.91667H13.9949"
          stroke="#212121"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const ProfileLogout = () => {
  return (
    <div>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.4228 14.141H11.375"
          stroke="#F75555"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0083 10.7388L25.4243 14.1408L22.0083 17.5428"
          stroke="#F75555"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0864 8.90159C18.7014 4.72492 17.1381 3.20825 10.9198 3.20825C2.63526 3.20825 2.63526 5.90325 2.63526 13.9999C2.63526 22.0966 2.63526 24.7916 10.9198 24.7916C17.1381 24.7916 18.7014 23.2749 19.0864 19.0983"
          stroke="#F75555"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const AppliedBack = () => {
  return (
    <div>
      {" "}
      <svg
        width="26"
        height="26"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.3333 14.3201C23.3333 14.763 23.0041 15.1291 22.577 15.1871L22.4583 15.1951L4.95825 15.1951C4.475 15.1951 4.08325 14.8033 4.08325 14.3201C4.08325 13.8771 4.41243 13.511 4.83952 13.4531L4.95825 13.4451L22.4583 13.4451C22.9415 13.4451 23.3333 13.8368 23.3333 14.3201Z"
          fill="#212121"
        />
        <path
          d="M12.6337 20.7284C12.9762 21.0694 12.9774 21.6234 12.6364 21.9658C12.3264 22.2771 11.8404 22.3064 11.4973 22.053L11.399 21.9685L4.34064 14.9405C4.0284 14.6296 3.99999 14.1418 4.25544 13.7987L4.34059 13.7004L11.3989 6.67126C11.7413 6.33026 12.2954 6.33141 12.6364 6.67382C12.9464 6.98511 12.9736 7.47128 12.7187 7.8133L12.6338 7.91126L6.19842 14.3208L12.6337 20.7284Z"
          fill="#212121"
        />
      </svg>
    </div>
  );
};

export const ArrowLeftIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19 12H6M12 5l-7 7 7 7" />
      </svg>
    </div>
  );
};

export const ChevronUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 15l-6-6-6 6" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const Experience = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-6 h-6 text-blue-700"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M10 2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v2.382l1.447.723.005.003.027.013.12.056c.108.05.272.123.486.212.429.177 1.056.416 1.834.655C7.481 13.524 9.63 14 12 14c2.372 0 4.52-.475 6.08-.956.78-.24 1.406-.478 1.835-.655a14.028 14.028 0 0 0 .606-.268l.027-.013.005-.002L22 11.381V9a3 3 0 0 0-3-3h-2V5a3 3 0 0 0-3-3h-4Zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1h6Zm6.447 7.894.553-.276V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5.382l.553.276.002.002.004.002.013.006.041.02.151.07c.13.06.318.144.557.242.478.198 1.163.46 2.01.72C7.019 15.476 9.37 16 12 16c2.628 0 4.98-.525 6.67-1.044a22.95 22.95 0 0 0 2.01-.72 15.994 15.994 0 0 0 .707-.312l.041-.02.013-.006.004-.002.001-.001-.431-.866.432.865ZM12 10a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};
export const Education = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-6 h-6 text-blue-700"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
        />
      </svg>
    </div>
  );
};

export const Sertifikat = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-blue-700"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M4 5a2 2 0 0 0-2 2v2.5a1 1 0 0 0 1 1 1.5 1.5 0 1 1 0 3 1 1 0 0 0-1 1V17a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2.5a1 1 0 0 0-1-1 1.5 1.5 0 1 1 0-3 1 1 0 0 0 1-1V7a2 2 0 0 0-2-2H4Z" />
      </svg>
    </div>
  );
};
export const LanguagesResume = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
      </svg>
    </div>
  );
};

export const Jobseekerstar = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-700 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeWidth="2"
          d="M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597l1.753-4.022Z"
        />
      </svg>
    </div>
  );
};
export const JobseekerstarApply = () => {
  return (
    <div>
      <svg
        class="w-6 h-6 text-yellow-300 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z" />
      </svg>
    </div>
  );
};
export const JobsFavoriteStar = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-5 h-5 "
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
        <line x1="4" y1="22" x2="4" y2="15"></line>
      </svg>
    </div>
  );
};

export const HRLocation = () => {
  return (
    <div>
      <svg
        class="w-6 h-6 text-gray-400 dark:text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#9ca3af "
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="10" r="3" />
        <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
      </svg>
    </div>
  );
};

export const HRUser = () => {
  return (
    <div>
      {" "}
      <svg
        class="w-6 h-6 text-gray-400 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

export const HRArrow = () => {
  return (
    <div>
      {" "}
      <svg
        width="15"
        height="17"
        viewBox="0 0 9 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.794922 10.58L5.37492 6L0.794922 1.41L2.20492 0L8.20492 6L2.20492 12L0.794922 10.58Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export const ChatIcon = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="nonzero"
          d="M6.43800037,12.0002892 L6.13580063,11.9537056 C5.24777712,11.8168182 4.5354688,11.1477159 4.34335422,10.2699825 L2.98281085,4.05392998 C2.89811796,3.66698496 2.94471512,3.2628533 3.11524595,2.90533607 C3.53909521,2.01673772 4.60304421,1.63998415 5.49164255,2.06383341 L22.9496381,10.3910586 C23.3182476,10.5668802 23.6153089,10.8639388 23.7911339,11.2325467 C24.2149912,12.1211412 23.8382472,13.1850936 22.9496527,13.6089509 L5.49168111,21.9363579 C5.13415437,22.1068972 4.73000953,22.1534955 4.34305349,22.0687957 C3.38131558,21.8582835 2.77232686,20.907987 2.9828391,19.946249 L4.34336621,13.7305987 C4.53547362,12.8529444 5.24768451,12.1838819 6.1356181,12.0469283 L6.43800037,12.0002892 Z M5.03153725,4.06023585 L6.29710294,9.84235424 C6.31247211,9.91257291 6.36945677,9.96610109 6.44049865,9.97705209 L11.8982869,10.8183616 C12.5509191,10.9189638 12.9984278,11.5295809 12.8978255,12.182213 C12.818361,12.6977198 12.4138909,13.1022256 11.8983911,13.1817356 L6.44049037,14.0235549 C6.36945568,14.0345112 6.31247881,14.0880362 6.29711022,14.1582485 L5.03153725,19.9399547 L21.6772443,12.0000105 L5.03153725,4.06023585 Z"
        />
      </svg>
    </div>
  );
};

export const ProfileImgIcon = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-40 h-40 me-3 text-gray-200 dark:text-gray-700"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
      </svg>
    </div>
  );
};

export const HelpCenter = () => {
  return (
    <div>
      {" "}
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 3.5C11.6245 3.5 11.3999 7.63761 9.98563 8.77361C8.60606 9.87968 5.83334 10.5628 5.83334 14C5.83334 18.6375 9.37085 22.1667 14 22.1667C18.6292 22.1667 22.1667 18.6375 22.1667 14C22.1667 10.5628 19.3939 9.87968 18.0143 8.77361C16.6 7.63761 16.3755 3.5 14 3.5ZM8.16667 14C8.16667 11.25 10.6181 11.0667 12.25 10.3042V9.33334C12.25 8.70625 13.1 8.16667 14 8.16667C14.9 8.16667 15.75 8.70625 15.75 9.33334V10.3042C17.3819 11.0667 19.8333 11.25 19.8333 14C19.8333 17.675 17.0167 20.5 14 20.5C10.9833 20.5 8.16667 17.675 8.16667 14ZM14 13.0833C14.4604 13.0833 14.8333 13.4563 14.8333 13.9167V17.5C14.8333 17.9604 14.4604 18.3333 14 18.3333C13.5396 18.3333 13.1667 17.9604 13.1667 17.5V13.9167C13.1667 13.4563 13.5396 13.0833 14 13.0833ZM14 9.33334C14.4604 9.33334 14.8333 9.70625 14.8333 10.1667C14.8333 10.6271 14.4604 11 14 11C13.5396 11 13.1667 10.6271 13.1667 10.1667C13.1667 9.70625 13.5396 9.33334 14 9.33334Z"
          fill="#212121"
        />
      </svg>
    </div>
  );
};

export const CompanyProfile = () => {
  return (
    <div>
      {" "}
      <svg
        width="24"
        height="24"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8333 23.8198C23.0185 23.8198 24.7907 22.0488 24.7918 19.8637V19.8613V16.7113C23.3487 16.7113 22.1797 15.5423 22.1785 14.0992C22.1785 12.6572 23.3475 11.487 24.7907 11.487H24.7918V8.337C24.7942 6.15067 23.0243 4.37733 20.8392 4.375H20.8322H7.16816C4.98183 4.375 3.20966 6.146 3.2085 8.33233V8.3335V11.5885C4.6015 11.5395 5.76933 12.6292 5.81833 14.0222C5.8195 14.0478 5.82066 14.0735 5.82066 14.0992C5.82183 15.54 4.65633 16.709 3.2155 16.7113H3.2085V19.8613C3.20733 22.0465 4.9795 23.8198 7.16466 23.8198H7.16583H20.8333Z"
          stroke="#3E9AAE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4333 10.5737L15.152 12.0285C15.222 12.1709 15.3573 12.27 15.5148 12.2934L17.1213 12.5279C17.5192 12.5862 17.6767 13.0739 17.3897 13.3527L16.2277 14.4844C16.1133 14.5952 16.062 14.755 16.0877 14.9125L16.3618 16.5109C16.4295 16.9064 16.0153 17.2074 15.6607 17.0207L14.2245 16.2659C14.0833 16.1912 13.9153 16.1912 13.7742 16.2659L12.3392 17.0207C11.9833 17.2074 11.5692 16.9064 11.6368 16.5109L11.911 14.9125C11.9378 14.755 11.8853 14.5952 11.771 14.4844L10.6102 13.3527C10.3232 13.0739 10.4807 12.5862 10.8773 12.5279L12.4838 12.2934C12.6413 12.27 12.7778 12.1709 12.8478 12.0285L13.5653 10.5737C13.7427 10.2144 14.256 10.2144 14.4333 10.5737Z"
          stroke="#3E9AAE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const ProtectedProfile = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-700 dark:text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
      </svg>
    </div>
  );
};

export const TourProfile = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5854 4.2002V7.29799"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5854 20.4683V23.0584"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5854 16.9679V10.7979"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.0832 16.3923C21.944 16.3923 21.944 11.6069 25.0832 11.6069C25.0832 6.06242 25.0832 4.0835 13.9998 4.0835C2.9165 4.0835 2.9165 6.06242 2.9165 11.6069C6.0557 11.6069 6.0557 16.3923 2.9165 16.3923C2.9165 21.9379 2.9165 23.9168 13.9998 23.9168C25.0832 23.9168 25.0832 21.9379 25.0832 16.3923Z"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const ChatBottom = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 "
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
        <line x1="4" y1="22" x2="4" y2="15"></line>
      </svg>
    </div>
  );
};

export const HomeJobseeker = () => {
  return (
    <div>
      <svg
        width="22"
        height="19"
        viewBox="0 0 22 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9728 17.3682C7.7338 17.3682 4.9668 16.8782 4.9668 14.9162C4.9668 12.9542 7.7158 11.2462 10.9728 11.2462C14.2118 11.2462 16.9788 12.9382 16.9788 14.8992C16.9788 16.8602 14.2298 17.3682 10.9728 17.3682Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9731 8.44876C13.0991 8.44876 14.8231 6.72576 14.8231 4.59976C14.8231 2.47376 13.0991 0.749756 10.9731 0.749756C8.84706 0.749756 7.12306 2.47376 7.12306 4.59976C7.11706 6.71776 8.82706 8.44176 10.9461 8.44876H10.9731Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.3623 7.39166C18.5993 7.06066 19.5113 5.93266 19.5113 4.58966C19.5113 3.18866 18.5183 2.01866 17.1963 1.74866"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9434 10.5444C19.6974 10.5444 21.1954 11.7334 21.1954 12.7954C21.1954 13.4204 20.6784 14.1014 19.8944 14.2854"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.58359 7.39166C3.34559 7.06066 2.43359 5.93266 2.43359 4.58966C2.43359 3.18866 3.42759 2.01866 4.74859 1.74866"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.002 10.5444C2.248 10.5444 0.75 11.7334 0.75 12.7954C0.75 13.4204 1.267 14.1014 2.052 14.2854"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const HomeOffice = () => {
  return (
    <div>
      {" "}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.30566 14.5742H16.8987"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 7.79836C2.5 5.35646 3.75 3.25932 6.122 2.77265C8.493 2.28503 10.295 2.4536 11.792 3.26122C13.29 4.06884 12.861 5.26122 14.4 6.13646C15.94 7.01265 18.417 5.69646 20.035 7.44217C21.729 9.26979 21.72 12.0755 21.72 13.8641C21.72 20.6603 17.913 21.1993 12.11 21.1993C6.307 21.1993 2.5 20.7288 2.5 13.8641V7.79836Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const AddAnnoun = () => {
  return (
    <div>
      <svg
        className="w-6 h-6"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.125 13H13.125V17H11.125V13H7.125V11H11.125V7H13.125V11H17.125M12.125 2C10.8118 2 9.51142 2.25866 8.29817 2.7612C7.08491 3.26375 5.98252 4.00035 5.05393 4.92893C3.17857 6.8043 2.125 9.34784 2.125 12C2.125 14.6522 3.17857 17.1957 5.05393 19.0711C5.98252 19.9997 7.08491 20.7362 8.29817 21.2388C9.51142 21.7413 10.8118 22 12.125 22C14.7772 22 17.3207 20.9464 19.1961 19.0711C21.0714 17.1957 22.125 14.6522 22.125 12C22.125 10.6868 21.8663 9.38642 21.3638 8.17317C20.8612 6.95991 20.1247 5.85752 19.1961 4.92893C18.2675 4.00035 17.1651 3.26375 15.9518 2.7612C14.7386 2.25866 13.4382 2 12.125 2Z"
          fill="#888888"
        />
      </svg>
    </div>
  );
};

export const QuickJobsWallet = () => {
  return (
    <svg
      class="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M12 14a3 3 0 0 1 3-3h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4a3 3 0 0 1-3-3Zm3-1a1 1 0 1 0 0 2h4v-2h-4Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M12.293 3.293a1 1 0 0 1 1.414 0L16.414 6h-2.828l-1.293-1.293a1 1 0 0 1 0-1.414ZM12.414 6 9.707 3.293a1 1 0 0 0-1.414 0L5.586 6h6.828ZM4.586 7l-.056.055A2 2 0 0 0 3 9v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2h-4a5 5 0 0 1 0-10h4a2 2 0 0 0-1.53-1.945L17.414 7H4.586Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const EducationJobseeker = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.82256 9.60864H4.31006C4.05131 9.60864 3.84131 9.39864 3.84131 9.13989C3.84131 8.88114 4.05131 8.67114 4.31006 8.67114H8.82256C9.08131 8.67114 9.29131 8.88114 9.29131 9.13989C9.29131 9.39864 9.08131 9.60864 8.82256 9.60864Z"
          fill="#828282"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.82256 6.99219H4.31006C4.05131 6.99219 3.84131 6.78219 3.84131 6.52344C3.84131 6.26469 4.05131 6.05469 4.31006 6.05469H8.82256C9.08131 6.05469 9.29131 6.26469 9.29131 6.52344C9.29131 6.78219 9.08131 6.99219 8.82256 6.99219Z"
          fill="#828282"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.03145 4.38159H4.30957C4.05082 4.38159 3.84082 4.17159 3.84082 3.91284C3.84082 3.65409 4.05082 3.44409 4.30957 3.44409H6.03145C6.2902 3.44409 6.5002 3.65409 6.5002 3.91284C6.5002 4.17159 6.2902 4.38159 6.03145 4.38159Z"
          fill="#828282"
        />
        <mask
          id="mask0_1614_6936"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="13"
          height="13"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.875 0.250244H12.2279V12.6939H0.875V0.250244Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1614_6936)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.94313 1.1875L4.1375 1.19C2.6825 1.19875 1.8125 2.09875 1.8125 3.59812V9.34562C1.8125 10.855 2.69063 11.7563 4.16 11.7563L8.96562 11.7544C10.4206 11.7456 11.2906 10.8444 11.2906 9.34562V3.59812C11.2906 2.08875 10.4131 1.1875 8.94313 1.1875ZM4.16062 12.6938C2.19562 12.6938 0.875 11.3481 0.875 9.34562V3.59812C0.875 1.5775 2.15438 0.264375 4.13438 0.2525L8.9425 0.25H8.94312C10.9081 0.25 12.2281 1.59562 12.2281 3.59812V9.34562C12.2281 11.3656 10.9487 12.6794 8.96875 12.6919L4.16062 12.6938Z"
            fill="#828282"
          />
        </g>
      </svg>
    </div>
  );
};

export const EducationExperience = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.49658 9.89178C6.23783 9.89178 6.02783 9.68178 6.02783 9.42303V7.8374C6.02783 7.57865 6.23783 7.36865 6.49658 7.36865C6.75533 7.36865 6.96533 7.57865 6.96533 7.8374V9.42303C6.96533 9.68178 6.75533 9.89178 6.49658 9.89178Z"
          fill="#828282"
        />
        <mask
          id="mask0_1614_6968"
          maskUnits="userSpaceOnUse"
          x="0"
          y="1"
          width="13"
          height="8"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.25 1.86255H12.7436V8.30692H0.25V1.86255Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1614_6968)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.1875 6.12067C2.6725 6.92755 4.545 7.36942 6.49375 7.36942C8.44625 7.36942 10.3206 6.92755 11.8062 6.12067V4.24442C11.8062 3.44755 11.1619 2.80005 10.3687 2.80005H2.63125C1.835 2.80005 1.1875 3.44505 1.1875 4.23817V6.12067ZM6.49375 8.30692C4.27812 8.30692 2.1425 7.77067 0.481875 6.79817C0.338125 6.71442 0.25 6.56067 0.25 6.3938V4.23817C0.25 2.92817 1.31812 1.86255 2.63125 1.86255H10.3688C11.6788 1.86255 12.7437 2.93067 12.7437 4.24442V6.3938C12.7437 6.56067 12.655 6.71442 12.5119 6.79817C10.8512 7.77067 8.71375 8.30692 6.49375 8.30692Z"
            fill="#828282"
          />
        </g>
        <mask
          id="mask1_1614_6968"
          maskUnits="userSpaceOnUse"
          x="3"
          y="0"
          width="7"
          height="3"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.84033 0.250244H9.15283V2.79768H3.84033V0.250244Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1614_6968)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.68408 2.79774C8.42533 2.79774 8.21533 2.58774 8.21533 2.32899V2.10024C8.21533 1.59712 7.80596 1.18774 7.30283 1.18774H5.69033C5.18721 1.18774 4.77783 1.59712 4.77783 2.10024V2.32899C4.77783 2.58774 4.56783 2.79774 4.30908 2.79774C4.05033 2.79774 3.84033 2.58774 3.84033 2.32899V2.10024C3.84033 1.08024 4.67033 0.250244 5.69033 0.250244H7.30283C8.32283 0.250244 9.15283 1.08024 9.15283 2.10024V2.32899C9.15283 2.58774 8.94283 2.79774 8.68408 2.79774Z"
            fill="#828282"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1216 12.5877H2.87161C1.57473 12.5877 0.482859 11.5746 0.384734 10.2809L0.265984 8.71274C0.246609 8.45462 0.440359 8.22899 0.698484 8.20962C0.957859 8.20024 1.18161 8.38337 1.20161 8.64212L1.31973 10.2096C1.38098 11.0171 2.06223 11.6502 2.87161 11.6502H10.1216C10.931 11.6502 11.6129 11.0171 11.6735 10.2096L11.7922 8.64212C11.8122 8.38337 12.0416 8.19962 12.2954 8.20962C12.5535 8.22899 12.7466 8.45462 12.7272 8.71274L12.6085 10.2809C12.5104 11.5746 11.4185 12.5877 10.1216 12.5877Z"
          fill="#828282"
        />
      </svg>
    </div>
  );
};

export const Location = () => {
  return (
    <div>
      {" "}
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 0L0 6.275V7.08333L5.7 9.3L7.91667 15H8.71667L15 0Z"
          fill="#828282"
        />
      </svg>
    </div>
  );
};

export const Salary = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5243 7.99739H10.9941C10.0651 7.99682 9.31209 7.24437 9.31152 6.31535C9.31152 5.38632 10.0651 4.63387 10.9941 4.6333H13.5243"
          stroke="#828282"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.2802 6.27675H11.0853"
          stroke="#828282"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.84229 0.875H10.2444C12.0558 0.875 13.5242 2.34344 13.5242 4.15479V8.64044C13.5242 10.4518 12.0558 11.9202 10.2444 11.9202H4.84229C3.03094 11.9202 1.5625 10.4518 1.5625 8.64044V4.15479C1.5625 2.34344 3.03094 0.875 4.84229 0.875Z"
          stroke="#828282"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.39746 3.71132H7.77181"
          stroke="#828282"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const JobType = () => {
  return (
    <div>
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 1.1875C3.57063 1.1875 1.1875 3.57063 1.1875 6.5C1.1875 9.42937 3.57063 11.8125 6.5 11.8125C9.42937 11.8125 11.8125 9.42937 11.8125 6.5C11.8125 3.57063 9.42937 1.1875 6.5 1.1875ZM6.5 12.75C3.05375 12.75 0.25 9.94625 0.25 6.5C0.25 3.05375 3.05375 0.25 6.5 0.25C9.94625 0.25 12.75 3.05375 12.75 6.5C12.75 9.94625 9.94625 12.75 6.5 12.75Z"
          fill="#828282"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.64434 8.8077C8.56246 8.8077 8.47996 8.78645 8.40434 8.74207L6.04809 7.33645C5.90684 7.25145 5.81934 7.09832 5.81934 6.93332V3.90332C5.81934 3.64457 6.02934 3.43457 6.28809 3.43457C6.54746 3.43457 6.75684 3.64457 6.75684 3.90332V6.66707L8.88496 7.93582C9.10684 8.06895 9.17996 8.35645 9.04746 8.57895C8.95934 8.72582 8.80371 8.8077 8.64434 8.8077Z"
          fill="#828282"
        />
      </svg>
    </div>
  );
};
